<div class="profile_page-container">
  <div class="profile_details">
    <div class="profile_details_header">
      Profile Details
    </div>
    <div class="progress_container">
      <div style="display: flex;align-items: center;font-family: var(--font)">
        <span id="progressPercent">0%</span> Profile Completed
      </div>
      <div class="progress-bar">
        <div class="progress-fill" id="progressFill"></div>
      </div>
    </div>
  </div>
  <div class="photo_header">Profile Photo</div>
  <div class="Profile_file">
    <div class="profile_circle" (click)="triggerFileInput()">
      <mat-icon *ngIf="croppedImage || profileImage" class="profile_camera_icon2">add_a_photo</mat-icon>
      <img *ngIf="croppedImage || profileImage; else showIcon" class="profile_image" [src]="profileImage || croppedImage">
      <ng-template #showIcon>
        <mat-icon class="profile_camera_icon">add_a_photo</mat-icon>
      </ng-template>
    
      <input type="file" id="files" #fileInput (change)="onFileSelected($event)" accept="image/*" style="display: none;" class="profile_file-input" />
    </div>
    
    
    <div style="text-align: center;">
      <div class="Profile_text">Upload any file here</div>
      <!-- <label class="profile_file-label" for="files">Browse Files</label> -->

      <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4 / 3"
        format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded($event)"
        (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"></image-cropper>

      <!-- <div class="profile_fileButton" *ngIf="profileImage.length > 0">
        <button class="profile_update" (click)="uploadFile($event)">Upload</button>
      </div> -->
      <div class="profile_fileButton">
        <button *ngIf="!profileImage || profileImage.length === 0" class="profile_update"
          (click)="uploadFile($event)">Upload</button>

        <button *ngIf="profileImage && profileImage.length > 0" class="profile_update"
          (click)="uploadFile($event)">Update</button>
      </div>

    </div>
  </div>
  <div class="profile_page_header">
    <div class="profile_title" style="font-size: 26px;
   font-family: var(--font);
   text-transform: uppercase;">My Profile</div>
  </div>
  <div class="profile_page_content">

    <div class="profile_page_section row" id="profileForm">
      <div class="col-md-6">
        <mat-form-field class="profile_page_block" appearance="outline">
          <mat-label style="font-family: var(--font);">First Name</mat-label>
          <input matInput id="firstName" style="font-family: var(--font);" type="text" [formControl]="FirstName">
          <mat-icon matSuffix style="color: var(--black-shade);">person</mat-icon>
          <mat-error *ngIf="FirstName.invalid && FirstName.touched">
            First Name is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="profile_page_block" appearance="outline">
          <mat-label style="font-family: var(--font);">Last Name</mat-label>
          <input matInput id="lastName" style="font-family: var(--font); " type="text" [formControl]="LastName">
          <mat-icon matSuffix style="color: var(--black-shade);">person</mat-icon>
          <mat-error *ngIf="LastName.invalid && LastName.touched">
            Last Name is required
          </mat-error>
        </mat-form-field>
      </div>


      <div class="col-md-6">
        <mat-form-field class="profile_page_block" appearance="outline">
          <mat-label style="font-family: var(--font);">Address Line 1</mat-label>
          <input matInput id="address1 " style="font-family: var(--font);" type="text" [formControl]="AddressLineOne">
          <mat-icon matSuffix style="color: var(--black-shade);">home</mat-icon>
          <mat-error *ngIf="AddressLineOne.invalid && AddressLineOne.touched">
            Address Line One is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="profile_page_block" appearance="outline">
          <mat-label style="font-family: var(--font);">Address Line 2</mat-label>
          <input matInput id="address2" style="font-family: var(--font);" type="text" [formControl]="AddressLineTwo">
          <mat-icon matSuffix style="color: var(--black-shade);">home</mat-icon>
          <mat-error *ngIf="AddressLineTwo.invalid && AddressLineTwo.touched">
            Address Line Two is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="profile_page_block" appearance="outline">
          <mat-label style="font-family: var(--font);">City</mat-label>
          <input matInput id="city" style="font-family: var(--font);" type="text" [formControl]="City">
          <mat-icon matSuffix style="color: var(--black-shade);">location_city</mat-icon>
          <mat-error *ngIf="City.invalid && City.touched">
            City is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="profile_page_block" appearance="outline">
          <mat-label style="font-family: var(--font);">State</mat-label>
          <input matInput id="state" style="font-family: var(--font);" type="text" [formControl]="State">
          <mat-icon matSuffix style="color: var(--black-shade);">location_city</mat-icon>
          <mat-error *ngIf="State.invalid && State.touched">
            State is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="profile_page_block" appearance="outline">
          <mat-label style="font-family: var(--font);">Pincode</mat-label>
          <input matInput id="pincode" style="font-family: var(--font);" type="number" [formControl]="Pincode">
          <mat-icon matSuffix style="color: var(--black-shade);">location_on </mat-icon>
          <mat-error *ngIf="Pincode.invalid && Pincode.touched">
            Pincode is required
          </mat-error>
        </mat-form-field>
      </div>
      <div><button class="update_profile" (click)="updateProfile()">UPDATE PROFILE</button></div>
    </div>
    <!-- <div class="password_details">
      <div class="password_header">Verification</div>
      <div class="row">
        <div class="col-md-6">
          <mat-form-field class="profile_page_block" appearance="outline">
            <mat-label style="font-family: var(--font);">E Mail</mat-label>
            <input 
              matInput 
              id="mail" 
              style="font-family: var(--font);" 
              type="text" 
              [(ngModel)]="email"
              #emailInput="ngModel" 
              required>
            <mat-icon matSuffix style="color: var(--black-shade);">mail</mat-icon>
          </mat-form-field>
        </div>
        <div class="verify col-md-6">
          <button 
            class="verify_button" 
            [disabled]="!email" 
            (click)="sendEmailVerification('Email')">
            Verify
          </button>
        </div>
      </div>      
      <div class="row">
        <div class="col-md-6">
          <mat-form-field class="profile_page_block" appearance="outline">
            <mat-label style="font-family: var(--font);">Mobile Number</mat-label>
            <input matInput id="mobile" style="font-family: var(--font);" type="text" [formControl]="MobileNumber">
            <mat-icon matSuffix style="color: var(--black-shade);">call</mat-icon>
            <mat-error *ngIf="MobileNumber.invalid && MobileNumber.touched">
              Mobile Number is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="verify col-md-6">
          <button class="verify_button"[disabled]="MobileNumber.invalid"  (click)="sendMobileVerification('Mobile')">Verify</button>
        </div> 
      </div>
      
    </div> -->
    <div class="password_details">
      <div class="password_header">Verification</div>
      <div class="row">
        <div class="col-md-6">
          <mat-form-field class="profile_page_block" appearance="outline">
            <mat-label style="font-family: var(--font);">E Mail</mat-label>
            <input 
              matInput 
              id="mail" 
              style="font-family: var(--font);" 
              type="text" 
              [(ngModel)]="email"
              #emailInput="ngModel" 
              required>
            <mat-icon matSuffix style="color: var(--black-shade);">mail</mat-icon>
          </mat-form-field>
        </div>
        <div class="verify col-md-6">
          <button 
            class="verify_button" 
            [disabled]="!email" 
            (click)="sendEmailVerification('Email')">
            Verify
          </button>
        </div>
      </div>      
      <div class="row">
        <div class="col-md-6">
          <mat-form-field class="profile_page_block" appearance="outline">
            <mat-label style="font-family: var(--font);">Mobile Number</mat-label>
            <input 
              matInput 
              id="mobile" 
              style="font-family: var(--font);" 
              type="text" 
              [(ngModel)]="mobileNumber"
              #mobileInput="ngModel"
              required>
            <mat-icon matSuffix style="color: var(--black-shade);">call</mat-icon>
            <mat-error *ngIf="mobileInput.invalid && mobileInput.touched">
              Mobile Number is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="verify col-md-6">
          <button 
            class="verify_button"
            [disabled]="!mobileNumber"
            (click)="sendMobileVerification('Mobile')">
            Verify
          </button>
        </div> 
      </div>
    </div>
    
    <div class="password_details" *ngIf="accounttype == 'WebSite' ">
      <div class="password_header">Password</div>
      <div class="col-md-6">
        <mat-form-field class="profile_page_block" appearance="outline">
          <mat-label style="font-family: var(--font);">Old Password</mat-label>
          <input matInput placeholder="Enter Password" [type]="p_hide ? 'password' : 'text'" [formControl]="Password">
          <button mat-icon-button matSuffix (click)="p_hide = !p_hide" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="p_hide">
            <mat-icon style="color: var(--black-shade);">{{p_hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>

        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="profile_page_block" appearance="outline">
          <mat-label style="font-family: var(--font);">New Password</mat-label>
          <input matInput placeholder="New Password" [type]="n_P_hide ? 'password' : 'text'" [formControl]="Password">
          <button mat-icon-button matSuffix (click)="n_P_hide = !n_P_hide" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="n_P_hide">
            <mat-icon style="color: var(--black-shade);">{{n_P_hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="Password.hasError('required')" style="font-family: var(--font);">
            New password is required.
          </mat-error>
          <mat-error *ngIf="!passwordsMatch() && confirmPassword.touched" style="font-family: var(--font);">
            Passwords do not match.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="profile_page_block" appearance="outline">
          <mat-label style="font-family: var(--font);">Confirm Password</mat-label>
          <input matInput placeholder="Confirm Password" [type]="c_p_hide ? 'password' : 'text'" [formControl]="confirmPassword">
          <button mat-icon-button matSuffix (click)="c_p_hide = !c_p_hide" [attr.aria-label]="'Hide Confirm password'"
            [attr.aria-pressed]="c_p_hide">
            <mat-icon style="color: var(--black-shade);">{{c_p_hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="confirmPassword.hasError('required')" style="font-family: var(--font);">
            Confirm password is required.
          </mat-error>
          <mat-error *ngIf="!passwordsMatch() && confirmPassword.touched" style="font-family: var(--font);">
            Passwords do not match.
          </mat-error>
        </mat-form-field>
      </div>
      <button class="submit_button" type="submit" (click)="profileUpdatePassword()">UPDATE PASSWORD</button>
    </div>
  </div>
</div>